import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import swal from "sweetalert2";
import Add from '../../../../modal/Settings/Catering_Management/FunctionType/Add_FunctionType';
import Edit from '../../../../modal/Settings/Catering_Management/FunctionType/Edit_FunctionType';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const FunctionType = () => {
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [functionTypes, setFunctionTypes] = useState([]);
  const [selectedFunctionType, setSelectedFunctionType] = useState(null);

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(25);
  const [searchTerm, setSearchTerm] = useState('');
    const [total_entries, setTotslEntries] = useState(0);
    const [datas, setData] = useState([]);

  const baseURL = process.env.REACT_APP_API_BASE_URL;

    const fetchFunctionTypes = () => {
    axios.get(`${baseURL}/functiontype/list`)
        .then(response => setFunctionTypes(response.data))
        .catch(error => console.error('Failed to fetch function types:', error));
    };

    useEffect(() => {
    fetchFunctionTypes();
    }, [baseURL]);

  const filteredFunctionTypes = functionTypes.filter(item =>
    item.function_type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredFunctionTypes.length / perPage);
  const paginatedFunctionTypes = filteredFunctionTypes.slice((page - 1) * perPage, page * perPage);

  const handleModalToggle_Add = () => {
    setModalType("Add");
    setSelectedFunctionType(null);
    setOpen(true);
  };

  const handleModalToggle_Edit = (item) => {
    setModalType("Edit");
    setSelectedFunctionType(item);
    setOpen(true);
  };

  const handleStatusToggle = async (item) => {
    const newStatus = item.status === '0' ? '1' : '0';
    try {
      await axios.put(`${baseURL}/functiontype/update_status/${item.sno}`, { status: newStatus });
      setFunctionTypes(prev =>
        prev.map(ft => ft.sno === item.sno ? { ...ft, status: newStatus } : ft)
      );
      toast.success('Status updated successfully!');
    } catch (error) {
      console.error('Status update failed:', error);
      toast.error('Failed to update status!');
    }
  };

  const handleDelete = (item) => {
    swal.fire({
      html: `
                <div class="alert alert-danger px-2 py-2" role="alert">
                    <strong>OOPS! </strong> You're about to lose one Function Type
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>
                <p class="text-center"><b>${item.function_type}</b></p>
                <div class="text-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                        <defs>
                            <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                <stop offset="0" stop-color="#5987dd"/>
                                <stop offset=".118" stop-color="#638bd6"/>
                                <stop offset=".316" stop-color="#7d98c3"/>
                                <stop offset=".572" stop-color="#a8aba3"/>
                                <stop offset=".871" stop-color="#e3c678"/>
                                <stop offset="1" stop-color="#ffd364"/>
                            </radialGradient>
                            <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                        </defs>
                        <g id="_27-feel_bad" data-name="27-feel bad">
                            <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                            <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                            <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                            <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="34" cy="22" r="1"/>
                            <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                            <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                            <circle class="cls-6" cx="16" cy="22" r="1"/>
                            <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                            <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                            <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                            <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                            <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                            <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                            <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                            <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                            <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                            <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                            <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                        </g>
                    </svg>
                </div>
            `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseURL}/functiontype/function_delete/${item.sno}`);
          setFunctionTypes(prev => prev.filter(ft => ft.sno !== item.sno));
          toast.success('Function Type deleted!');
          swal.fire({
                    title: 'Complaint Type Deleted!',
                    text: `${item.function_type}`,
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
        } catch (error) {
          console.error('Delete failed:', error);
          swal.fire('Error!', 'Failed to delete the Function Type.', 'error');
        }
      }else{
        swal.fire({
                    title: 'Delete Process Cancelled',
                    text: `${item.function_type}`,
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonText: 'OK',
                    customClass: {
                        title: 'fs-6',
                        confirmButton: 'btn btn-sm btn-primary',
                    },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                });
      }
    });
  };

  useEffect(() => {
    if (page > totalPages) setPage(1);
  }, [perPage, searchTerm, totalPages, page]);

  return (
    <>
      <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
        <div className='mb-0'>
          <div className="mb-0 px-0">
            <h4 className='breadcrumb-header'>Function Type</h4>
          </div>
          <ol className="breadcrumb fs-7">
            <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item"><Link to='/settings'>Settings</Link></li>
            <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
            <li className="breadcrumb-item active">Catering Management</li>
          </ol>
        </div>
        <Button className="btn btn-primary btn-sm" onClick={handleModalToggle_Add}>
          <span className="me-2"><i className="fa-solid fa-plus fs-8"></i></span>
          <span>Function Type</span>
        </Button>

        {open && modalType === "Add" && (
        <Add
            show={open}
            onClose={() => setOpen(false)}
            onCreated={() => {
            setOpen(false); 
            fetchFunctionTypes(); 
            }}
        />
        )}

        {open && modalType === "Edit" && (
        <Edit
            show={open}
            onClose={() => setOpen(false)}
            initialFunctionType={selectedFunctionType?.function_type}
            initialDescription={selectedFunctionType?.description}
            id={selectedFunctionType?.sno}
            onUpdated={() => {
            setOpen(false);           
            fetchFunctionTypes();     
            }}
        />
        )}

      </div>

      <div className="table-container">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <label className="me-2">Show</label>
            <select
              className="form-select d-inline w-auto"
              style={{ fontSize: '0.85rem', height: '30px' }}
              value={perPage}
              onChange={e => { setPerPage(Number(e.target.value)); setPage(1); }}
            >
              {[10, 25, 50, 100].map(n => (
                <option key={n} value={n}>{n}</option>
              ))}
            </select>
          </div>

          <div>
            <input
              type="text"
              style={{ fontSize: '0.85rem', height: '40px' }}
              placeholder="Search..."
              className="form-control"
              value={searchTerm}
              onChange={e => { setSearchTerm(e.target.value); setPage(1); }}
            />
          </div>
        </div>

        <table className="table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2">
          <thead>
            <tr className="text-start text-white fw-bold fs-6 gs-0 th_head">
              <th className='min-w-50px text-start'>S.No</th>
              <th className='min-w-150px'>Function Type</th>
              <th className='min-w-100px'>Status</th>
              <th className='min-w-100px'>Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-600 fw-semibold fs-7">
            {paginatedFunctionTypes.length === 0 ? (
              <tr><td colSpan={4} className="text-center p-3">No Function Types Found</td></tr>
            ) : (
              paginatedFunctionTypes.map((item, index) => (
                <tr key={item.sno}>
                  <td className='text-start'>
                    <label className='text-black font-w400 fs-7'>{(page - 1) * perPage + index + 1}</label>
                  </td>
                  <td>
                    <label className='text-black font-w400 fs-7'>{item.function_type}</label>
                    {item.description && (
                      <OverlayTrigger
                        overlay={
                          <Tooltip className='toltip-popover'>
                            <span className='fs-8 text-white fw-semibold'>{item.description}</span>
                          </Tooltip>
                        }
                      >
                        <i className="fa-solid fa-circle-info text-black fs-7 ms-2"></i>
                      </OverlayTrigger>
                    )}
                  </td>
                  <td>
                    <div className="form-check form-switch d-flex align-items-center mb-3">
                      <input
                        className="form-check-input me-2"
                        type="checkbox"
                        role="switch"
                        checked={item.status === '0'}
                        onChange={() => handleStatusToggle(item)}
                      />
                    </div>
                  </td>
                  <td>
                    <span className="text-end">
                      <OverlayTrigger
                        trigger="['hover', 'focus']"
                        placement="bottom"
                        overlay={
                          <Tooltip className='toltip-popover'>
                            <span className='fs-8 text-white fw-semibold'>Edit</span>
                          </Tooltip>
                        }
                      >
                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleModalToggle_Edit(item)}>
                          <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                        </Button>
                      </OverlayTrigger>

                      {/* <OverlayTrigger
                        trigger="['hover', 'focus']"
                        placement="bottom"
                        overlay={
                          <Tooltip className='toltip-popover'>
                            <span className='fs-8 text-white fw-semibold'>Delete</span>
                          </Tooltip>
                        }
                      >
                        <Button variant="primary tp-btn-light px-2 py-1 me-1" onClick={() => handleDelete(item)}>
                          <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                        </Button>
                      </OverlayTrigger> */}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
            <div className="d-flex justify-content-between align-items-center mt-3">
                        {/* Bottom left: Showing x to y of z entries */}
                        <div>
                            {filteredFunctionTypes.length > 0 ? (
                                <span className="text-muted">
                                    Showing {(page - 1) * perPage + 1} to {(page - 1) * perPage + filteredFunctionTypes.length} of {filteredFunctionTypes.length} entries
                                </span>
                            ):(
                                <span className="text-muted">
                                    Showing 0 to 0 of 0 entries
                                </span>
                            )}
                        </div>

                        {/* Bottom right: Pagination */}
                        {/* <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>Previous</button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                <li key={i} className={`page-item ${page === i + 1 ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(i + 1)}>{i + 1}</button>
                                </li>
                                ))}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>Next</button>
                                </li>
                            </ul>
                        </nav> */}
                        
                        <nav>
                            <ul className="pagination mb-0" style={{ fontSize: '0.75rem' }}>
                                {/* Previous Button */}
                                <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page - 1)}>
                                    Previous
                                </button>
                                </li>

                                {/* First Page */}
                                <li className={`page-item ${page === 1 ? 'active' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(1)}>
                                    1
                                </button>
                                </li>

                                {/* Left Ellipsis */}
                                {page > 4 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                                )}

                                {/* Pages Around Current */}
                                {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(p => p >= page - 1 && p <= page + 1 && p !== 1 && p !== totalPages)
                                .map(p => (
                                    <li key={p} className={`page-item ${page === p ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(p)}>
                                        {p}
                                    </button>
                                    </li>
                                ))}

                                {/* Right Ellipsis */}
                                {page < totalPages - 3 && (
                                <li className="page-item disabled">
                                    <span className="page-link" style={{ padding: '0.25rem 0.5rem' }}>...</span>
                                </li>
                                )}

                                {/* Last Page */}
                                {totalPages > 1 && (
                                <li className={`page-item ${page === totalPages ? 'active' : ''}`}>
                                    <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(totalPages)}>
                                    {totalPages}
                                    </button>
                                </li>
                                )}

                                {/* Next Button */}
                                <li className={`page-item ${page === totalPages ? 'disabled' : ''}`}>
                                <button className="page-link" style={{ padding: '0.25rem 0.5rem' }} onClick={() => setPage(page + 1)}>
                                    Next
                                </button>
                                </li>
                            </ul>
                        </nav>

                </div>
      </div>
    </>
  );
};

export default FunctionType;
